import noop from 'lodash/noop';

import { EmbeddedDisplayUntil } from 'modules/domains/campaign';
import { SearchField } from 'modules/domains/segmentation';
import { FilterInputsList } from 'modules/journey';
import { SearchQueryValidationErrors } from 'modules/journey/components/RuleBuilder';
import { IS_NOT_SET, IS_SET } from 'utils/comparatorTypes';
import { UNSUBSCRIBED_CHANNELS, UNSUBSCRIBED_MESSAGE_TYPES } from 'utils/fieldConstants';
import DisplayUntilItem from './DisplayUntilItem';
import { QUERY_STUB } from './DisplayUntilTakeover.constants';

interface PropertyChangeItemProps {
  /** The search query */
  searchQuery?: EmbeddedDisplayUntil['searchQuery'];
  /** The errors on the search query */
  errors?: SearchQueryValidationErrors;
  /** Callback whe the query has changed */
  onChange?: (searchQuery?: EmbeddedDisplayUntil['searchQuery']) => void;
}

export const PROPERTY_CHANGE_ITEM_ID = 'property-change-item';

const PropertyChangeItem = ({
  searchQuery,
  errors = {},
  onChange = noop,
}: PropertyChangeItemProps) => {
  const query = searchQuery?.searchQueries?.[0] || QUERY_STUB;

  const handleOnChange = ([newQuery]: SearchField[]) => {
    // If the comparator is IS_SET or IS_NOT_SET, we want to set the value to
    // an empty string as it is not needed.
    const parsedQuery = [IS_SET, IS_NOT_SET].includes(newQuery.comparatorType)
      ? { ...newQuery, value: '' }
      : newQuery;
    onChange({
      ...searchQuery,
      searchQueries: [parsedQuery],
    } as EmbeddedDisplayUntil['searchQuery']);
  };

  return (
    <DisplayUntilItem data-test={PROPERTY_CHANGE_ITEM_ID} onClose={() => onChange(undefined)}>
      User field changes
      <FilterInputsList
        dataType="user"
        trigger=""
        queries={[query]}
        // @ts-ignore -- more issues due to different typing of query
        onSearchQueriesUpdate={handleOnChange}
        canAddFilter={false}
        canDelete={false}
        NestComponent={null}
        queriesErrors={{ 0: errors }}
        isDisabled={false}
        isPropertyChanges={true}
        propertyMapDisallowedIds={[UNSUBSCRIBED_MESSAGE_TYPES, UNSUBSCRIBED_CHANNELS]} // for property changed events, we want to remove these properties from the dropdown.
      />
    </DisplayUntilItem>
  );
};

export default PropertyChangeItem;
